import { Wizard } from "./wizard";
import { WizardButton } from "./wizard-button";

/** ###TypeDocName:sd-wizard-step### */
export class WizardStepBindings {
  /** The step name that this step should be identified as. */
  stepName = "@";
  /** Callback to invoke when the step is activated. The parameter "wizardState" is passed as an argument to this function. */
  onStepActivated = "&";
  /** True if the back button should be hidden while on this step. */
  hideBackButton = "<";
  /** Use auto height for correct spacing allowing overflow to work properly */
  autoHeight = "<?";
}

export interface WizardStep {
  activateStep(state: {}): void;
  goBack(): void;
  finish(): void;
  stepName: string;
  advanceWizard(stepName: string): void;
  registerStepButton(button: WizardButton): void;
}

export class WizardStepController implements WizardStep {
  public stepName: string;
  public parentWizard: Wizard;
  public onStepActivated: (state: {}) => void;
  public stepButtons: WizardButton[] = [];
  public autoHeight: boolean;

  constructor() {}

  public $onInit() {
    this.parentWizard.registerStep(this);
  }

  public activateStep(state: {}) {
    this.stepButtons.length = 0;
    this.onStepActivated({ wizardState: state });
  }

  public goBack() {
      this.parentWizard.undoStep();
      setTimeout(function (): void {
          let focussedElement = <HTMLElement>document.querySelector('sd-collect-confirm-conclude > sd-wizard > div > ng-transclude > sd-wizard-step:nth-child(1) > div > div > sd-button:nth-child(2) > button');
          if (focussedElement) {
              focussedElement.focus();
          }
      }, 500);
  }

  public advanceWizard(targetStep: string) {
    this.parentWizard.stepComplete(targetStep);
  }

  public registerStepButton(button: WizardButton) {
    this.stepButtons.push(button);
    if (button && this.parentWizard.activeStepName === "confirm") {
      setTimeout(function (): void {
        let focussedElement = <HTMLElement>document.querySelector('button[type="Submit"]');
        if (focussedElement) {
          focussedElement.focus();
        }
      }, 500);
    } else if (button && this.parentWizard.activeStepName === "conclude") {
      setTimeout(function (): void {
        let focussedElement = <HTMLElement>document.querySelector("body > sd-dialog > button");
        if (focussedElement) {
          focussedElement.focus();
        }
      }, 2000);
    }
  }

  public finish() {
    this.parentWizard.finish();
  }
}
export const sdWizardStep: ng.IComponentOptions = {
  bindings: <any>new WizardStepBindings(),
  controller: WizardStepController,
  require: {
    parentWizard: "^sdWizard"
  },
  templateUrl: "../ShellCommon/Controls/wizard/wizard-step.html",
  transclude: true
};
